// src/entities/form/ui-tailwind/FieldWrapper.tsx
'use client';

import type { FC, PropsWithChildren } from 'react';
import type { BaseFieldProps } from '@/entities/form/model-tailwind/form.model';
import cn from 'classnames';

type FieldWrapperProps = { element?: 'div' | 'label' };

const FieldWrapper: FC<PropsWithChildren<Omit<BaseFieldProps, 'size' | 'name'> & FieldWrapperProps>> = ({
  label,
  error,
  readOnly,
  disabled,
  children,
  element,
  wrapperClassName,
  extra,
  horizontal,
}) => {
  const Element = element || 'label';

  return (
    <div className={cn('tw-wrapper w-full', wrapperClassName)}>
      <Element className={cn('tw-label block w-full', horizontal && 'tw-horizontal', readOnly && !disabled && 'readonly')}>
        {label ? (
          <div className='flex items-center justify-between mb-2'>
            <div className='tw-labelText'>{label}</div>
            {extra}
          </div>
        ) : null}

        <div className='relative pb-1'>
          {children}
          <div className={cn('absolute left-0 top-full translate-y-[2px] text-[var(--Error)] text-xs leading-tight', error ? 'opacity-100' : 'opacity-0 pointer-events-none')} aria-live='polite'>
            {error || ''}
          </div>
        </div>
      </Element>
    </div>
  );
};

export default FieldWrapper;
